<template>
  <div class="ds-table-container">
    <table class="proptable">
      <thead>
        <tr>
          <th style="width: 10%" class="prop">Property</th>
          <th style="width: 10%" class="type">Type</th>
          <th style="width: 10%" class="def">Default</th>
          <th class="desc">Description</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(prop, index) in properties" :key="index">
          <t>
            <td class="prop">
              <code>{{ prop.name }}</code>
            </td>
            <td class="type">{{ prop.type }}</td>
            <td class="def">
              <code v-if="prop.defaultValue">{{ prop.defaultValue }}</code>
            </td>
            <td class="desc">{{ prop.description }}</td>
          </t>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "StyleVars",
  props: {
    component: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      properties: []
    };
  },
  created() {
    const component = this.$root.$options.components[this.component];
    const props = component.props || component.options.props;
    if (props) {
      Object.keys(props).forEach((key) => {
        this.properties.push({
          name: key,
          defaultValue:
            props[key].default !== undefined && props[key].default !== null
              ? props[key].default.toString()
              : null,
          type:
            typeof props[key].type === "object"
              ? props[key].type.map((t) => t.name).join(" or ")
              : props[key].type.name,
          description: props[key].description
        });
      });
    }
  }
});
</script>

<style scoped lang="scss">
.ds-table-container {
  overflow-x: auto;
  .proptable,
  td,
  th {
    border: 1px solid #ddd;
    text-align: left;
  }

  table {
    border-collapse: collapse;
    width: 100%;
  }
  th,
  td {
    padding: 15px;
  }
}
</style>
